export class CreateZeroEtlPolicyInput {
    'name';
    'enabled';
    'resourceSelector';
    'catalogIds';
    'routingPolicy';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "resourceSelector",
            "baseName": "resourceSelector",
            "type": "ZeroEtlResourceSelector",
            "format": ""
        },
        {
            "name": "catalogIds",
            "baseName": "catalogIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "routingPolicy",
            "baseName": "routingPolicy",
            "type": "ZeroEtlRoutingPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateZeroEtlPolicyInput.attributeTypeMap;
    }
    constructor() {
    }
}
